import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { UserProfileModalComponent } from "./user-profile-modal/user-profile-modal.component";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbCarouselModule, NgbModalModule } from "@ng-bootstrap/ng-bootstrap";
import { PipeModule } from "src/app/data/pipe/pipe.module";
import { AddApartmentComponent } from './add-apartment/add-apartment.component';
import { TranslateModule } from "@ngx-translate/core";
import { ProductDetailModalComponent } from "./product-detail-modal/product-detail-modal.component";
// import { CarouselModule } from "ngx-owl-carousel-o";
// import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [UserProfileModalComponent, AddApartmentComponent,ProductDetailModalComponent],
    imports: [CommonModule, FormsModule, NgbModalModule, ReactiveFormsModule, PipeModule, TranslateModule , NgbCarouselModule],
    exports: [UserProfileModalComponent, AddApartmentComponent,ProductDetailModalComponent],
      schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class ModalsModule { }